import { CardBody as o } from "../../Card/Body/CardBody.js";
const d = o;
export {
  d as CollapsibleCardBody
};
